import React from 'react';
import {
    required,
    Edit, SimpleForm, ReferenceInput, SelectInput,
    BooleanInput, NumberInput
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import moment from "moment";
import * as apiClient from "../../apiClient";
import { CreateToolbar } from "../../CreateToolbar";
import { useStyles } from "../../formStyles";
import { makeStyles } from '@material-ui/core/styles';
import { Create } from 'react-admin';

const useCustomStyles = makeStyles((theme) => ({
    formContainer: {
        maxHeight: '80vh',  // Limit height to enable scrolling
        overflowY: 'auto',  // Enable vertical scrolling
        padding: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            maxHeight: '70vh', // Adjust for smaller screens
        },
    }
}));

export const AddScoringTypeDetail = props => {
    const classes = useStyles();
    const customClasses = useCustomStyles();

    const initialValues = {
        isActive: true,
        
    };

    const handleSubmit = (formdata) => { 
        let date = formdata.date ? moment(formdata.date).format() : null;
        let userid = parseInt(localStorage.getItem("userId")) || 0; 
        date = date.toString().replace("+05:30", "");
        let data={...formdata};
        
        data.scoringTypeId= parseInt(props.scoringTypeId);
        data.date= date;
        data.isActive= formdata.isActive;
        data.createdBy= userid;
        data.createdDate= date;

        

        apiClient.addEntiyRecord(data).then(res => {
            props.onClose();
        }).catch(err => {
            console.log(err);
        });
    };


    return (
        <Create {...props}>
            <div className={customClasses.formContainer}>
                <SimpleForm
                    onSubmit={handleSubmit}
                    initialValues={initialValues}
                    toolbar={<CreateToolbar onSave={handleSubmit}  label="Save" onClose={props.onCancel} />}
                    variant="outlined"
                >
                    <ReferenceInput label="Heading Type" fullWidth
                        perPage={5000} source="typeId"
                        reference="statuses"
                        filter={{ statusType: 'SCORINGTYPE' }}
                        sort={{ field: 'status', order: 'ASC' }}
                    >
                        <SelectInput optionText="status" variant="outlined" fullWidth validate={[required()]} />
                    </ReferenceInput>

                    {[...Array(5)].map((_, index) => (
                        <RichTextInput key={index} source={`level0${index + 1}`} label={`Level ${index + 1}`} />
                    ))}

                    <NumberInput source="sortingOrder" label="Sorting Order" validate={[required()]} />
                    <BooleanInput source="isActive" label="Is Active" initialValues={true} />
                </SimpleForm>
            </div>
        </Create>
    )
};
